import { useContext } from 'react';

import CollaborationContext, { CollaborationValues } from './context';

const useCollaboration = (): CollaborationValues =>
    useContext(CollaborationContext);

export default useCollaboration;
